// TODO(RBAC, parent #641 #647): admin only
import { create } from '@bufbuild/protobuf'
import type { ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import { getWorkflowTemplate } from '@ebalance/proto/bffuser/v1/workflow_template_service-WorkflowTemplateService_connectquery'
import {
  GetWorkflowTemplateRequestSchema,
  type GetWorkflowTemplateResponse,
} from '@ebalance/proto/bffuser/v1/workflow_template_service_pb'
import type { UseQueryResult } from '@tanstack/react-query'

export function useGetWorkflowTemplate(
  id: string,
): UseQueryResult<GetWorkflowTemplateResponse, ConnectError> {
  return useQuery(
    getWorkflowTemplate,
    create(GetWorkflowTemplateRequestSchema, { id }),
    // 直接編集の Get 失敗はフォーム内で通知し、キャンセルで一覧へ戻れるようにする。
    // 全体既定の throwOnError: true へ委ねると ErrorLayout へ遷移してしまう。
    { enabled: id !== '', throwOnError: false },
  )
}
